import React, { useState } from 'react';

import { Grid } from '@mui/material';
import moment from 'moment';
import QRCode from 'react-qr-code';  // Import react-qr-code
import { useApi } from '../ContextApi/ContextApi';

import '../UI/Template.css';
import Logo24_7 from '../Pages/Shared/24-7Logo/24-7logo';

const Template3 = ({reportData ,QRurl}) => {
      const [FontStyle,setFontStyles] = useState([]);
      const [DRS,setDRS] = useState([]);
  const currentDateTime = new Date();
  const FormateCurrentDate = moment(currentDateTime).format('D MMM YYYY | HH:mm:ss');
  const Username = sessionStorage.getItem("FirstName") + sessionStorage.getItem("LastName");
  const { Comment,isheader } = useApi();

  const groupByCategoryAndSubCategory = (data) => {
    return data.reduce((result, item) => {
      const category = item.categorY_CODE;
      const subCategory = item.suB_CATEGORY_CODE;

      if (!result[category]) {
        result[category] = {
          categoryValue: item.categorY_VALUE,
          subCategories: {},
        };
      }

      if (!result[category].subCategories[subCategory]) {
        result[category].subCategories[subCategory] = {
          subCategoryValue: item.suB_CATEGORY_VALUE,
          items: [],
        };
      }

      result[category].subCategories[subCategory].items.push(item);
      return result;
    }, {});
  };

  const groupedData = groupByCategoryAndSubCategory(reportData);

  const formatTextWithLineBreaks = (text) => {
    return text.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < text.split('\n').length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const LabName = reportData.find((x) => x.laboratoryName != '' && x.laboratoryName != null)?.laboratoryName;
  const qrCodeValue = QRurl;

  return (
    <>
        {/* Header Section (Patient Info, Lab Info, QR Code) */}
        <div className="print-header" style={{ padding: '1rem' }}>
          <h3 style={{ fontFamily: FontStyle[0]?.fontfamily || 'Georgia serif',fontWeight: '900', fontSize: '30px' }} >
            {LabName}
          </h3>
          <Grid container spacing={8}>
            <Grid item xs={8}>
              <div style={{ textAlign: 'start' }}>
                <span style={{ fontFamily: FontStyle[0]?.fontfamily || 'Georgia serif' }}>
                  {reportData?.[0]?.laboratoryAddress}
                </span><br />
                <span style={{ fontFamily: FontStyle[0]?.fontfamily || 'Georgia serif' }}>
                  Contact: {reportData?.[0]?.laboratoryContactNumber}
                </span><br />
                <span style={{ fontFamily: FontStyle[0]?.fontfamily || 'Georgia serif' }}>
                   Email:{reportData?.[0]?.laboratoryEmail}
                </span>
              </div>
            </Grid>
              <Grid xs={4} style={{ textAlign: 'center', marginTop: '20px' }}>
                <QRCode value={qrCodeValue} size={100} />
                <p style={{fontFamily: FontStyle[0]?.fontfamily || 'Georgia serif'}}>Scan to Download PDF</p>
              </Grid>
               
          </Grid>
          <hr></hr>
           <Grid container spacing={8}>
               <Grid item xs={8}>
              <div style={{fontFamily: FontStyle[0]?.fontfamily || 'Georgia serif',}}>
                <div style={{ textAlign: 'start' }}>
                  <span>Mr No:&nbsp;{reportData?.[0]?.patientID}-{sessionStorage.getItem('LabID')}</span>
                </div>
                <div style={{ textAlign: 'start' }}>
                  <span>Patient Name:&nbsp;{reportData?.[0]?.patientName}</span>
                </div>
                <div style={{ textAlign: 'start' }}>
                  <span>Age|Gender:&nbsp;{reportData?.[0]?.age} Years|{reportData?.[0]?.sex}</span>
                </div>
                <div style={{ textAlign: 'start' }}>
                  <span>Phone Number:&nbsp;{reportData?.[0]?.contactNumber}</span>
                </div>
                <div style={{ textAlign: 'start' }}>
                  <span >Referred by:&nbsp;{reportData?.[0]?.referredBy}</span>
                </div>
                <div style={{ textAlign: 'start' }}>
                  <span>Reported At: {moment(reportData?.[0]?.createdAt).format('D MMM YYYY | HH:mm:ss')}</span>
                </div>
              </div>
            </Grid>
            <Grid item xs={4}>
                 <div>
                    <Logo24_7 />
                 </div>
            </Grid>
           </Grid>
          
            {/* <hr></hr> */}
        </div> 
        {/* Content Section */}
        <div className="print-content"  style={{padding:'0px 10px'}}>
          {/* Table Section */}
          {Object.keys(groupedData).map((category, index) => (
            <div key={index} style={{fontFamily: FontStyle[0]?.fontfamily || 'Georgia serif'}}>
              <h5 className='common-FontWeight ' style={{ textAlign: 'center' }}>
                {groupedData[category].categoryValue}
              </h5>
              {Object.keys(groupedData[category].subCategories).map((subCategory, subIndex) => (
                <div key={subIndex}>
                  <h6 className='common-FontWeight ' style={{ textAlign: 'left' }}>
                    {groupedData[category].subCategories[subCategory].subCategoryValue}
                  </h6>
                  <table style={{ width: '100%' }}>
                    <thead style={{ backgroundColor: 'lightgray' }}>
                      <tr>
                        <th>Test Description</th>
                        <th>Result</th>
                        <th>Unit</th>
                        <th>Normal Range</th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupedData[category].subCategories[subCategory].items.map((data, index) => (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{data.testName}</td>
                            <td style={{ fontWeight: 'bold' }}>{data.testResult}</td>
                            <td>{formatTextWithLineBreaks(data.unit)}</td>
                            <td>{formatTextWithLineBreaks(data.normalRange)}</td>
                          </tr>
                          {data.comment && data.comment.trim() !== '' && (
                            <tr>
                              <td colSpan={4} style={{ paddingLeft: '20px', fontStyle: 'italic' }}>
                                {data.comment}
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </table>
                  <hr />
                </div>
              ))}
            </div>
          ))}

          <div style={{fontFamily: FontStyle[0]?.fontfamily || 'Georgia serif'}}>
            <span>Printed at: {FormateCurrentDate}</span> &nbsp; <span>Printed By: {Username}</span>
          </div>
        </div>
    </>
  );
};

export default Template3;
